// *****************************************************************************************************************
// Custom JavaScript
// *****************************************************************************************************************


// =================================================================================================================
// Breakpoint Manager
// =================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =================================================================================================================
// Scrollbar alignfull fix
// =================================================================================================================
// TODO: implement on front end
// document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");



// =================================================================================================================
// Nav Bar
// =================================================================================================================

// Set up constants
// const nav = $("#main-nav"); // Nav bar
// const adminBar = $('#wpadminbar'); // WordPress Admin Bar
const nav = document.getElementById("main-nav");
const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar


// Change Nav state after scrolling scrolled past start
// -----------------------------------------------------------------------------------------------------------------
if (nav) {
    window.onscroll = function() {
        const scrollPoint = 20; // pixel value after which state change is triggered
        this.scrollY > scrollPoint ? nav.classList.add('scrolled') : nav.classList.remove('scrolled');
    };
}



// Check for WordPress admin bar and pushes Nav down if it exists
// -----------------------------------------------------------------------------------------------------------------
if (adminBar) {
    nav.style.top = adminBar.offsetHeight + 'px';

    window.addEventListener('resize', function (){
        nav.style.top = adminBar.offsetHeight + 'px';
    });
}



// =================================================================================================================
// Splide
// =================================================================================================================

import Splide from '@splidejs/splide';

// Solutions Carousel
// ------------------------------------------------------------------------------------------------------------------
const tabCarousels = document.querySelectorAll('.tab-carousel');

if (tabCarousels.length) {
    tabCarousels.forEach(function(tabCarousel) {

        // Instantiate Splide tab carousel
        const carousel = new Splide(tabCarousel, {
            arrows: true,
            pagination: false,
            perPage: 1,
        }).mount();

        // Carousel tab buttons
        const tabs = tabCarousel.querySelectorAll('.tab-btn');
        const tabName = tabCarousel.querySelector('.tab-name');
        tabs.forEach(function(tab, index){
            if (index === 0) {
                tab.classList.add('active');
                tab.setAttribute('disabled', true);
            }
            tab.addEventListener('click', function (){
                carousel.go(index);
            })
        })

        // Carousel move event
        carousel.on('move', (index)=> {
            tabs.forEach(function(tab, tabIndex){
                if (tabIndex !== index) {
                    tab.classList.remove('active');
                    tab.removeAttribute('disabled');
                } else {
                    tab.classList.add('active');
                    tab.setAttribute('disabled', true);
                    tabName.innerText = tab.innerText.trim();
                }
            })
        })

    })
}


// Vertical Slider
// ------------------------------------------------------------------------------------------------------------------
if (document.querySelector('.vertical-content-slider')) {
    const verticalSlider = new Splide('.vertical-content-slider', {
        arrows: true,
        type: 'fade',
        pagination: false,
        perPage: 1,
        drag: false,
    }).mount();

    // On slide move, update index
    verticalSlider.on('move', (index) => {
        let slideIndex = verticalSlider.root.querySelector('.slide-index');
        slideIndex.textContent = index + 1;
    })
}



// =================================================================================================================
// Industry Slider
// =================================================================================================================
const industrySlider = document.querySelector('.industry-slider');
if (industrySlider) {
    let industrySlides = industrySlider.querySelectorAll('.slide');

    // Set the default state
    industrySlideTransition(industrySlides, 0);

    industrySlides.forEach((slide, index) => {
        // On Mouse Over Event
        slide.addEventListener('mouseover', function(){
            industrySlideTransition(industrySlides, index)
        })

        // On Button Focus Event (accessibility option)
        slide.querySelector('.industry-link').addEventListener("focus", function(){
            industrySlideTransition(industrySlides, index)
        });
    });

    // Fix for screen size changes
    document.addEventListener('breakpointChange', function (){
        if (breakpointManager.matchesBreakpointsDown('md')) {
            industrySlides.forEach((slide) => {
                slide.classList.remove('active');
                slide.querySelector('.content').style.transform = 'translateY(0)';
            })
        }
    })
}


/**
 * Industry Slide Transition
 * Sets the active slide and deactivates the other slides
 *
 * @param {NodeListOf} slides The slides as queried by querySelectorAll
 * @param {int} index The index of the active slide
 */
function industrySlideTransition(slides, index){
    slides.forEach((slide, i) => {
        if (breakpointManager.matchesBreakpointsUp('md')) {
            if (index === i) {
                slide.classList.add('active');
                slide.querySelector('.content').style.transform = 'translateY(0)';
            } else {
                slide.classList.remove('active');
                let contentHeight = slide.querySelector('.content-hidden').offsetHeight;
                slide.querySelector('.content').style.transform = `translateY(${contentHeight}px)`;
            }
        }
    })
}



// =================================================================================================================
// Testimonials Carousel
// =================================================================================================================
const testimonialsCarousel = document.querySelectorAll('.testimonials-carousel .splide');
if (testimonialsCarousel.length) {
    testimonialsCarousel.forEach(function(testimonialCarousel) {
        const carousel = new Splide(testimonialCarousel, {
            arrows: true,
            pagination: false,
            perPage: 1,
        }).mount();
    });
}



// =================================================================================================================
// Hero Slider
// =================================================================================================================
const heroSlider = document.querySelectorAll('.hero-slider .splide');
if (heroSlider ) {
    heroSlider.forEach(function(heroSlider) {
        const slider = new Splide(heroSlider, {
            arrows: true,
            pagination: true,
            perPage: 1,
        }).mount();
    });
}



// =================================================================================================================
// Videos Carousel
// =================================================================================================================
const videoCarousels = document.querySelectorAll('.video-carousel .splide');
if (videoCarousels.length) {
    videoCarousels.forEach(function(videoCarousel) {
        const carousel = new Splide(videoCarousel, {
            arrows: true,
            pagination: false,
            perPage: 1,
        }).mount();
    });
}



// =================================================================================================================
// Tab Slider
// =================================================================================================================
const tabSliders = document.querySelectorAll('.tab-slider .splide');
if (tabSliders.length) {
    tabSliders.forEach(function(slider) {
        const carousel = new Splide(slider, {
            arrows: true,
            pagination: false,
            perPage: 1,
            type: 'fade',
        }).mount();

        // Carousel tab buttons
        const tabs = slider.querySelectorAll('.tab-btn');
        const tabNames = slider.querySelectorAll('.tab-name');
        tabs.forEach(function(tab, index){
            if (index === 0) {
                tab.classList.add('active');
                tab.setAttribute('disabled', 'true');
            }
            tab.addEventListener('click', function (){
                carousel.go(index);
            })
        })

        // Buttons in slide
        const nextSlideBtn = slider.querySelectorAll('.arrow-next');
        const prevSlideBtn = slider.querySelectorAll('.arrow-prev');
        nextSlideBtn.forEach(function(btn){
            btn.addEventListener('click', function (){
                carousel.go('>');
            })
        })
        prevSlideBtn.forEach(function(btn){
            btn.addEventListener('click', function (){
                carousel.go('<');
            })
        })

        // Carousel move event
        carousel.on('move', (index)=> {
            tabs.forEach(function(tab, tabIndex){
                if (tabIndex !== index) {
                    tab.classList.remove('active');
                    tab.removeAttribute('disabled');
                } else {
                    tab.classList.add('active');
                    tab.setAttribute('disabled', 'true');
                }
            })
            tabNames.forEach(function(tab, tabIndex){
                if (tabIndex !== index) {
                    tab.classList.remove('active');
                } else {
                    tab.classList.add('active');
                }
            })
        })
    });
}



// =================================================================================================================
// Logos Slider
// =================================================================================================================
const logosSlider = document.querySelectorAll('.logos-slider .splide');
if (logosSlider.length) {
    logosSlider.forEach(function(logoSlider) {
        let hasArrows = logoSlider.classList.contains('has-arrows');
        const slider = new Splide(logoSlider, {
            arrows: hasArrows,
            padding: hasArrows ? { left: '6rem', right: '6rem' } : false,
            pagination: false,
            autoplay: true,
            interval: 2000,
            type: 'loop',
            perPage: 4,
            perMove: 1,
            gap: '6rem',
            breakpoints: {
                1400: {
                    gap: hasArrows ? '5rem' : '4rem',
                    padding: hasArrows ? { left: '5rem', right: '5rem' } : false,
                },
                1200: {
                    perPage: 3,
                    gap: '6rem',
                    padding: hasArrows ? { left: '4.5rem', right: '4.5rem' } : false,
                },
                992: {
                    gap: '4rem',
                    padding: hasArrows ? { left: '4rem', right: '4rem' } : false,
                },
                768: {
                    perPage: 2,
                    gap: '5rem',
                    padding: false,
                    arrows: false,
                },
                576: {
                    gap: '2rem',
                },
            }
        }).mount();
    });
};



// =================================================================================================================
// Video Modals
// =================================================================================================================
const videoModals = document.querySelectorAll(".video-modal");
videoModals.forEach( modal => {

    // Play video in modal open (This can error out if the iframe is slow to load)
    modal.addEventListener('show.bs.modal', function(){
        let iframe = this.querySelector('iframe');
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'playVideo' }
            ), 'https://www.youtube.com'
        );
    })

    // Pause video on modal close
    modal.addEventListener('hide.bs.modal', function (){
        let iframe = this.querySelector('iframe');
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'pauseVideo' }
            ), 'https://www.youtube.com'
        );
    })
})



// =================================================================================================================
// Partner and Post Filters
// =================================================================================================================
const partnerResetBtn = document.getElementById("partner-reset-btn");
const postResetBtn = document.getElementById("post-reset-btn");
const webinarResetBtn = document.getElementById("webinar-reset-btn");
const partnerFormFilter = document.getElementById("partner-filters");
const postFormFilter = document.getElementById("post-filters");
const webinarFormFilter = document.getElementById("webinar-filters");

// Reset Button Functionality
if (partnerResetBtn){
    partnerResetBtn.addEventListener("click", () => {
        window.location.assign(window.location.origin + '/partners' + '#primary')
    });
}
if (postResetBtn){
    postResetBtn.addEventListener("click", () => {
        window.location.assign(window.location.origin + '/blog')
    });
}
if (webinarResetBtn){
    webinarResetBtn.addEventListener("click", () => {
        window.location.assign(window.location.origin + '/webinars')
    });
}

// Submit form on select change
if (partnerFormFilter){
    let selects = document.querySelectorAll('#partner-filters .form-select');
    selects.forEach( select => {
        select.addEventListener('change', function (){
            // Handle if filtering from beyond page 1
            if (window.location.href.indexOf("/page/") > -1) {
                partnerFormFilter.action = window.location.origin + '/partners';
                partnerFormFilter.submit();
            } else {
                partnerFormFilter.submit();
            }
        })
    })
}
if (postFormFilter){
    let selects = document.querySelectorAll('#post-filters .form-select');
    selects.forEach( select => {
        select.addEventListener('change', function (){
            // Handle if filtering from beyond page 1
            if (window.location.href.indexOf("/page/") > -1) {
                postFormFilter.action = window.location.origin + '/blog';
                postFormFilter.submit();
            } else {
                postFormFilter.submit();
            }
        })
    })
}
if (webinarFormFilter){
    let selects = document.querySelectorAll('#webinar-filters .form-select');
    selects.forEach( select => {
        select.addEventListener('change', function (){
            // Handle if filtering from beyond page 1
            if (window.location.href.indexOf("/page/") > -1) {
                webinarFormFilter.action = window.location.origin + '/webinars';
                webinarFormFilter.submit();
            } else {
                webinarFormFilter.submit();
            }
        })
    })
}


// JS Filter on Resource Library Page
const categoryFilter = document.getElementById("category-filter");
const resources = document.querySelectorAll(".resource");
if (categoryFilter && resources){
    let resetBtn = document.getElementById('filter-reset-btn');

    resetBtn.addEventListener('click', function (){
        categoryFilter.value = "";
        resetBtn.disabled = true;
        resources.forEach(function(resource){
            resource.classList.remove('hide');
        });
    });

    categoryFilter.addEventListener('change', function (){
        let selectedCat = this.value;
        resetBtn.disabled = false;

        resources.forEach(function(resource){
            let dataCats = resource.dataset.category;
            if (dataCats) {
                let resourceCats = dataCats.split(" ");
                if (resourceCats.includes(selectedCat)) {
                    resource.classList.remove('hide')
                } else {
                    resource.classList.add('hide')
                }
            }

        });
    })
}




